import React, { useContext } from "react";
import SvgClose from "../../icons/SvgClose";
import { MONTHLY, WEEKLY } from "./cohorts.constants";
import Modal from "antd/lib/modal";
import DatePicker from "antd/lib/date-picker";
import TimePicker from "antd/lib/time-picker";
import Form from "antd/lib/form";
import SvgCalendar from "../../icons/SvgCalendar";
import clock from "../../assets/Clock.svg";
import dayjs from "dayjs";
import BaseSelect from "../BaseSelect";
import { daysOfWeek } from "./CreateStep2";
import QalortButton from "../Button";
import { AppContext } from "../../context";

function NewSessionModal({
  visible,
  setVisible,
  setNewSchedule,
  newSchedule,
  setSchedules,
}) {
  const {
    formFields: { frequency, schedules },
  } = useContext(AppContext);

  return (
    <Modal
      visible={visible}
      footer={null}
      closeIcon={
        <SvgClose className="text-light w-[18px] h-[18px] absolute right-5 top-5" />
      }
      onCancel={() => {
        setVisible(false);
      }}
      className="recurring-modal !w-[470px]"
      title={
        <>
          <h6 className="mb-2.5 font-semibold text-dark">Recurring schedule</h6>
          <p className="mb-0 p-xs text-main font-medium">
            Set up your recurring schedule. You can set up a date that’d be
            recurring every week, month, bi-weekly or yearly.
          </p>
        </>
      }
    >
      <div className="max-h-[600px] overflow-auto">
        <div>
          <div className="relative">
            {frequency === MONTHLY && (
              <div className="grid gap-4 grid-cols-2">
                <div className="w-full">
                  <span className="text-main font-medium p-xs">Date</span>
                  <DatePicker
                    className="recurring-date"
                    id="date_input"
                    placeholder="DD/MM/YY"
                    suffixIcon={<SvgCalendar className="text-light" />}
                    style={{
                      borderRadius: "0.5rem",
                      border: "1px solid #eceef8",
                      fontSize: "0.9375rem",
                      backgroundColor: "#fff",
                      height: 56,
                      width: "100%",
                      color: "#30307d",
                    }}
                    onChange={(e) =>
                      setNewSchedule({
                        ...newSchedule,
                        date: e.format("YYYY-MM-DD"),
                      })
                    }
                    value={newSchedule.date ? dayjs(newSchedule.date) : null}
                  />
                </div>
                <div className="w-full">
                  <label className="text-main font-medium p-xs">
                    Start Time
                  </label>
                  <Form.Item name="start_time" className="!mb-0">
                    <TimePicker
                      className="recurring-date"
                      placeholder="8:00"
                      suffixIcon={<img src={clock} alt="" />}
                      use12Hours
                      minuteStep={30}
                      showSecond={false}
                      changeOnBlur={true}
                      style={{
                        borderRadius: "0.5rem",
                        border: "1px solid #eceef8",
                        fontSize: "0.9375rem",
                        backgroundColor: "#fff",
                        height: 56,
                        width: "100%",
                        color: "#30307d",
                      }}
                      onChange={(e) =>
                        setNewSchedule({
                          ...newSchedule,
                          start_time: e.format("HH:mm"),
                        })
                      }
                    />
                  </Form.Item>
                </div>
                <div className="w-full">
                  <label className="text-main font-medium p-xs">End Time</label>
                  <Form.Item name="end_time" className="!mb-0">
                    <TimePicker
                      className="recurring-date"
                      placeholder="10:00"
                      suffixIcon={<img src={clock} alt="" />}
                      use12Hours
                      minuteStep={30}
                      showSecond={false}
                      changeOnBlur={true}
                      style={{
                        borderRadius: "0.5rem",
                        border: "1px solid #eceef8",
                        fontSize: "0.9375rem",
                        backgroundColor: "#fff",
                        height: 56,
                        width: "100%",
                        color: "#30307d",
                      }}
                      onChange={(e) =>
                        setNewSchedule({
                          ...newSchedule,
                          end_time: e.format("HH:mm"),
                        })
                      }
                    />
                  </Form.Item>
                </div>
              </div>
            )}

            {frequency === WEEKLY && (
              <div className="grid gap-4 grid-cols-2">
                <div className="w-full">
                  <BaseSelect
                    label="Select Day"
                    placeholder="e.g Mondays"
                    name="dayOfWeek"
                    options={daysOfWeek.map((day, i) => ({
                      label: day,
                      value: i + 1,
                    }))}
                    selectClassName="h-14"
                    onChange={(e) =>
                      setNewSchedule({
                        ...newSchedule,
                        day_of_week: e,
                      })
                    }
                  />
                </div>
                <div className="w-full">
                  <label className="text-main font-medium p-xs">
                    Start Time
                  </label>
                  <Form.Item name="start_time" className="!mb-0">
                    <TimePicker
                      className="recurring-date"
                      placeholder="8:00"
                      suffixIcon={<img src={clock} alt="" />}
                      use12Hours
                      minuteStep={30}
                      showSecond={false}
                      changeOnBlur={true}
                      style={{
                        borderRadius: "0.5rem",
                        border: "1px solid #eceef8",
                        fontSize: "0.9375rem",
                        backgroundColor: "#fff",
                        height: 56,
                        width: "100%",
                        color: "#30307d",
                      }}
                      onChange={(e) =>
                        setNewSchedule({
                          ...newSchedule,
                          start_time: e.format("HH:mm"),
                        })
                      }
                    />
                  </Form.Item>
                </div>
                <div className="w-full">
                  <label className="text-main font-medium p-xs">End Time</label>
                  <Form.Item name="end_time" className="!mb-0">
                    <TimePicker
                      className="recurring-date"
                      placeholder="10:00"
                      suffixIcon={<img src={clock} alt="" />}
                      use12Hours
                      minuteStep={30}
                      showSecond={false}
                      changeOnBlur={true}
                      style={{
                        borderRadius: "0.5rem",
                        border: "1px solid #eceef8",
                        fontSize: "0.9375rem",
                        backgroundColor: "#fff",
                        height: 56,
                        width: "100%",
                        color: "#30307d",
                      }}
                      onChange={(e) =>
                        setNewSchedule({
                          ...newSchedule,
                          end_time: e.format("HH:mm"),
                        })
                      }
                    />
                  </Form.Item>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <QalortButton
        onClick={() => {
          setSchedules((prev) => [...schedules, newSchedule]);
          setVisible(false);
        }}
        className="!py-3 w-full mt-[20px]"
        type="primary"
      >
        Proceed
      </QalortButton>
    </Modal>
  );
}

export default NewSessionModal;
